import React from "react"
import { PROCESS_ENV } from "~Shared/config/env.utils"
import { SnowEffect } from "../snowEffect"

export const FullScreen = ({ children, ...rest }: { children: React.ReactNode; [key: string]: any }) => (
    <main className={"min-w-screen min-h-screen overflow-hidden"}>
        {PROCESS_ENV.IS_USING_CHRISTMAS_THEME && (
            <>
                <div id="snow" className="absolute w-full h-full overflow-hidden" style={{ zIndex: 1 }} />
                <SnowEffect />
            </>
        )}

        {children}
    </main>
)
